module.exports = __webpack_public_path__ + "img/instagram2.29f5028e.svg";